<template>
  <van-list
    v-model="loading"
    :finished="finished"
    @load="onLoad"
    finished-text="没有更多数据了"
    loading-text="数据加载中..."
  >
    <div v-for="(item, index) in list" :key="index">
      <slot name="item" :item="item"></slot>
    </div>
  </van-list>
</template>

<script>
export default {
  name: "List",
  props: {
    getData: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      pageNum: 1,
      pageSize: 5,
    };
  },
  methods: {
    async onLoad() {
      this.loading = true;
      const { data, total } = await this.getData({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      });
      this.list = this.list.concat(data);
      this.loading = false;
      this.pageNum++;
      if (this.list.length >= total) {
        this.finished = true;
      }
    },
    async reset() {
      this.list = [];
      this.loading = false;
      this.finished = false;
      this.pageNum = 1;
      await this.onLoad();
    },
  },
};
</script>
